
export const resolveActivities = (page = undefined, perpage = undefined, deleted = undefined) => {
    return ['$stateParams', 'activitiesService', ($stateParams, activitiesService) => {
        if (!$stateParams.filtertext) {
            return activitiesService.findAll(page, perpage, deleted).then(list => list);
        }

        return activitiesService.search('name', $stateParams.filtertext, page).then(list => list);
    }];
};

export const resolveActivity = (param = 'activity') => {
    return ['$stateParams', 'activitiesService', ($stateParams, activitiesService) => {
        return $stateParams[param] && $stateParams[param] > 0 ? activitiesService.findById($stateParams[param]) : {};
    }];
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/resolvers/activities.resolver.js